// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"360":"e6731e4c","757":"3be85b77"}[chunkId] + ".chunk.css";
};